<template>
  <section>
    <nav class="school-levels">
      <router-link to="/course-schedule/elementary-school">國小</router-link>
      <router-link to="/course-schedule/junior-high-school">國中</router-link>
      <router-link to="/course-schedule/high-school">高中</router-link>
    </nav>
    <section>
      <PulseLoader
        class="loading"
        :loading="state == 'loading'"
        color="#f1d85b"
        size="20px"
      />
      <ErrorView class="error" v-if="state == 'error'" />
      <div v-if="state == 'display'">
        <nav class="locations">
          <router-link
            v-for="location in locations"
            :key="location"
            :to="`/course-schedule/${schoolLevel}/${location}`"
          >
            {{ getSchoolName(location) }}
          </router-link>
        </nav>
        <Divider class="divider" />
        <div class="subject-select" v-if="schoolLevel != 'high-school'">
          <el-select v-model="subjectSelect" placeholder="選擇科目">
            <el-option
              v-for="item in subjectOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="course-null" v-show="schoolSchedules.length <= 0">
          暫無資料
        </div>
        <CourseSchedule
          class="schedule"
          :schedules="schoolSchedules"
          :keyPrefix="`${schoolLevel}-${subjectSelect}`"
        />
      </div>
    </section>
  </section>
</template>

<script>
import _ from "lodash";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import ErrorView from "@/components/ErrorView.vue";
import Divider from "@/components/Divider.vue";
import CourseSchedule from "@/components/CourseSchedule.vue";
import { withApiClient } from "@/api/ApiClient.js";
import { getSchoolName } from "@/utils/schools.js";

const CourseScheduleImpl = {
  components: {
    ErrorView,
    PulseLoader,
    Divider,
    CourseSchedule
  },
  data() {
    return {
      state: "idle",
      schedules: [],
      subjectSelect: ""
    };
  },
  mounted() {
    this.fetchCourseSchedule();
  },
  watch: {
    $route() {
      this.subjectSelect = "";
      this.fetchCourseSchedule();
    }
  },
  computed: {
    subjectOptions() {
      switch (this.schoolLevel) {
        case "elementary-school":
          return [
            {
              value: "",
              label: "所有科目"
            },
            {
              value: "math",
              label: "數學"
            },
            {
              value: "natural",
              label: "自然"
            },
            {
              value: "chinese",
              label: "國文"
            },
            {
              value: "english",
              label: "英文"
            },
            {
              value: "society",
              label: "社會"
            },
            {
              value: "all",
              label: "全科"
            }
          ];
        case "junior-high-school":
          return [
            {
              value: "",
              label: "所有科目"
            },
            {
              value: "math",
              label: "數學"
            },
            {
              value: "natural",
              label: "自然"
            },
            {
              value: "chinese",
              label: "國文"
            },
            {
              value: "english",
              label: "英文"
            },
            {
              value: "society",
              label: "社會"
            },
            {
              value: "all",
              label: "全科"
            }
          ];
        default:
          break;
      }
    },
    locations() {
      return Array.from(
        new Set(
          this.schedules.map(it => it.location).filter(it => it != "none")
        )
      );
    },
    schoolSchedules() {
      return this.schedules.filter(
        it =>
          (!this.$route.params.location ||
            it.location == this.$route.params.location) &&
          (!this.subjectSelect || _.includes(it.subjects, this.subjectSelect))
      );
    },
    schoolLevel() {
      return this.$route.params.school_level;
    }
  },
  methods: {
    fetchCourseSchedule() {
      this.state = "loading";
      this.apiClient
        .fetchCourseSchedule(this.$route.params.school_level)
        .subscribe(
          resp => {
            this.schedules = resp.list;
            if (this.locations.length > 0 && !this.$route.params.location) {
              this.$router
                .replace({
                  name: "school-course-schedule",
                  params: {
                    school_level: this.$route.params.school_level,
                    location: this.locations[0]
                  }
                })
                .catch(() => {});
            }
            this.state = "display";
          },
          () => {
            this.state = "error";
          }
        );
    },
    getSchoolName: getSchoolName
  }
};

export default withApiClient(CourseScheduleImpl);
</script>

<style lang="scss" scoped>
.subject-select {
  display: flex;
  justify-content: center;
  margin: 17px 0;
}

.course-null {
  text-align: center;
  margin: 20px;
}
.loading,
.error {
  text-align: center;
  margin: 30px auto;
}

nav.school-levels {
  margin: 60px auto;
  display: grid;
  grid-template-areas: ". . .";
  justify-content: center;
  grid-gap: 48px;

  a {
    background-color: #f3f3f4;
    border-radius: 14px;
    text-decoration: none;
    color: #6b6b6b;
    font-size: 16px;
    font-weight: bold;
    padding: 10px 40px;
    text-align: center;

    &.router-link-active,
    &:hover {
      background-color: #c4cb7a;
      color: white;
    }
  }
}

nav.locations {
  margin-bottom: 20px;
  display: flex;
  justify-content: center;

  a {
    font-size: 16px;
    font-weight: bold;
    color: #6c6c6c;
    border-bottom: 2px solid transparent;
    text-decoration: none;
    margin: 0 40px;

    &:hover,
    &.router-link-active {
      border-bottom: 2px solid #f1d85b;
    }
  }
}

.divider {
  width: 95%;
  max-width: 920px;
  margin: auto;
}

.schedule {
  width: 90%;
  max-width: 900px;
  margin: auto;
  padding-bottom: 100px;
}

@media (max-width: 850px) {
  .divider {
    margin: auto 10px !important;
  }
}

@media (max-width: 480px) {
  nav.school-levels {
    margin: 40px auto 20px !important;
    grid-gap: 30px !important;
    a {
      padding: 9px 20px !important;
      font-size: 12px !important;
    }
  }

  nav.locations {
    a {
      font-size: 12px !important;
      margin: 0 20px !important;
    }
  }
}
</style>
